"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-54448bf2"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "call",
    id: "call"
};
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", {
    class: "icon icon-call",
    title: "通话"
}, null, -1); });
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", {
    class: "icon icon-down-arrow",
    title: "通话"
}, null, -1); });
var _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
var _hoisted_5 = {
    class: "call-main-content",
    ref: "dialog"
};
var _hoisted_6 = {
    key: 0,
    class: "icon icon-call-voice"
};
var _hoisted_7 = {
    key: 0,
    class: "icon icon-call-video"
};
var _hoisted_8 = { class: "uncall-dialog-body" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d;
    var _component_Transfer = vue_1.resolveComponent("Transfer");
    var _component_Dialog = vue_1.resolveComponent("Dialog");
    return (_ctx.handleShowCallIcon(_ctx.conversation, _ctx.isH5))
        ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
            vue_1.createElementVNode("div", {
                class: "call-icon",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return (_ctx.toggleShowSelectDialog && _ctx.toggleShowSelectDialog.apply(_ctx, args));
                    })
            }, _hoisted_4),
            vue_1.withDirectives(vue_1.createElementVNode("div", {
                class: vue_1.normalizeClass(["call-main", [_ctx.isH5 && 'call-main-h5']])
            }, [
                vue_1.createElementVNode("div", _hoisted_5, [
                    ((_ctx.conversation.type === 'C2C' && ((_a = _ctx.chat_setting) === null || _a === void 0 ? void 0 : _a.c_realtime_audio) === 'open') ||
                        (_ctx.conversation.type === 'GROUP' && ((_b = _ctx.chat_setting) === null || _b === void 0 ? void 0 : _b.group_realtime_audio) === 'open'))
                        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                            key: 0,
                            class: "call-main-voice",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.onClickCall(1)); })
                        }, [
                            (_ctx.isH5)
                                ? (vue_1.openBlock(), vue_1.createElementBlock("i", _hoisted_6))
                                : vue_1.createCommentVNode("", true),
                            vue_1.createTextVNode(" " + vue_1.toDisplayString(_ctx.$t("TUIChat.语音通话")), 1)
                        ]))
                        : vue_1.createCommentVNode("", true),
                    ((_ctx.conversation.type === 'C2C' && ((_c = _ctx.chat_setting) === null || _c === void 0 ? void 0 : _c.c_realtime_video) === 'open') ||
                        (_ctx.conversation.type === 'GROUP' && ((_d = _ctx.chat_setting) === null || _d === void 0 ? void 0 : _d.group_realtime_video) === 'open'))
                        ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                            key: 1,
                            class: "call-main-video",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.onClickCall(2)); })
                        }, [
                            (_ctx.isH5)
                                ? (vue_1.openBlock(), vue_1.createElementBlock("i", _hoisted_7))
                                : vue_1.createCommentVNode("", true),
                            vue_1.createTextVNode(" " + vue_1.toDisplayString(_ctx.$t("TUIChat.视频通话")), 1)
                        ]))
                        : vue_1.createCommentVNode("", true),
                    vue_1.createElementVNode("footer", null, [
                        (_ctx.isH5)
                            ? (vue_1.openBlock(), vue_1.createElementBlock("span", {
                                key: 0,
                                class: "close",
                                onClick: _cache[3] || (_cache[3] = vue_1.withModifiers(function ($event) { return (_ctx.showSelectDialog = false); }, ["stop"]))
                            }, vue_1.toDisplayString(_ctx.$t("TUIChat.取消")), 1))
                            : vue_1.createCommentVNode("", true)
                    ])
                ], 512)
            ], 2), [
                [vue_1.vShow, _ctx.showSelectDialog]
            ]),
            vue_1.createVNode(_component_Dialog, {
                show: _ctx.showGroupUserDialog,
                isH5: _ctx.isH5,
                isHeaderShow: false,
                isFooterShow: false,
                background: false,
                "onUpdate:show": _cache[4] || (_cache[4] = function (e) { return (_ctx.showGroupUserDialog = e); })
            }, {
                default: vue_1.withCtx(function () {
                    var _a;
                    return [
                        vue_1.createVNode(_component_Transfer, {
                            isSearch: true,
                            title: _ctx.showTitle,
                            list: _ctx.searchUserList,
                            isH5: _ctx.isH5,
                            isRadio: ((_a = _ctx.conversation) === null || _a === void 0 ? void 0 : _a.type) === 'isC2C',
                            onSearch: _ctx.handleSearch,
                            onSubmit: _ctx.submit,
                            onCancel: _ctx.cancle
                        }, null, 8, ["title", "list", "isH5", "isRadio", "onSearch", "onSubmit", "onCancel"])
                    ];
                }),
                _: 1
            }, 8, ["show", "isH5"]),
            vue_1.createVNode(_component_Dialog, {
                show: _ctx.showUnsupportDialog,
                isH5: _ctx.isH5,
                isHeaderShow: true,
                isFooterShow: true,
                background: true,
                title: "欢迎使用音视频服务",
                "onUpdate:show": _cache[5] || (_cache[5] = function (e) { return (_ctx.showUnsupportDialog = e); })
            }, {
                default: vue_1.withCtx(function () { return [
                    vue_1.createElementVNode("div", null, [
                        vue_1.createElementVNode("div", _hoisted_8, [
                            vue_1.createElementVNode("p", null, vue_1.toDisplayString(_ctx.errorContent), 1)
                        ])
                    ])
                ]; }),
                _: 1
            }, 8, ["show", "isH5"])
        ]))
        : vue_1.createCommentVNode("", true);
}
exports.render = render;
